
<script context="module">

import { 
  VmIcon 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-icon', VmIcon);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className = '';

export let style = '';
export { className as class };

export let name = undefined;
export let src = undefined;
export let label = undefined;
export let library = undefined;
export let icons = 'material';
export const redraw = (...args) => __ref.redraw(...args);
export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => {
  

  __mounted = true;
});



const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-icon
  class={className}
  style={style}
  name={name}
  src={src}
  label={label}
  library={library}
  icons={icons}
  on:vmLoad={onEvent}
  on:vmError={onEvent}
  bind:this={__ref}
>
  <slot></slot>
</vm-icon>
  